import type { FunctionComponent } from 'react';
import Loader from '../../../generic/Loader';
import styles from './SettingsPageContent.module.less';

//  Optionally show a Loader if the component is still loading data.
type Props = {
  isLoading?: boolean
};

/**
 * ProjectSettingsPageContent serves as the base/"wrapper" component
 * for the project settings pages.
 *
 * Note: this is essentially a Panel, but has slightly different border
 * and padding styling. This could potentially be factored out into a generic
 * at some point in the future.
 */
const ProjectSettingsPageContent: FunctionComponent<Props> = ({ children, isLoading }) => (
  <main className={styles.content}>
    {isLoading ? (
      <div className={styles.loader}>
        <Loader size={80} />
      </div>
    ) : children}
  </main>
);

export default ProjectSettingsPageContent;
